/**
 * The app's toaster, in the theme the app is actually drawing.
 *
 * The previous local copy read `useTheme` from `next-themes`, whose provider
 * this app never mounts — so it always answered "system" and the toasts
 * followed the operating system, not the app. The design-tokens provider's
 * `theme` is the resolved light/dark; the palette comes from `@tonnie/ui` (WCAG AA in both).
 * Mounted inside `BusinessThemeProvider`.
 */
import { Toaster } from '@tonnie/ui';

import { useTheme } from '@tonnie/design-tokens';

export function AppToaster() {
  const { theme } = useTheme();
  return <Toaster theme={theme} />;
}
